<template>
  <div class="my-5">
    <v-layout row wrap>
      <v-layout>
        <v-flex xs6>
          <div class="body-2">{{ listing.address.full }}</div>
          <div class="body-1 grey--text">
            {{ listing.address.city }},&nbsp;{{ listing.address.state }}&nbsp;
            {{ listing.address.postalCode }}
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="mx-1" xs3>
          <div class="body-2 text-xs-center">
            {{ listing.listPrice | currency('$', 0) }}
          </div>
          <div class="body-1 grey--text text-xs-center">Price</div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="border-left mx-1" xs4>
          <div class="body-2 text-xs-center">
            {{ listing.property.bedrooms }}
          </div>
          <div class="body-1 grey--text text-xs-center">Bedrooms</div>
        </v-flex>
        <v-flex class="border-left mx-1" xs4>
          <div class="body-2 text-xs-center">
            {{
              setNumBaths(
                listing.property.bathsFull,
                listing.property.bathsHalf
              )
            }}
          </div>
          <div class="body-1 grey--text text-xs-center">Baths</div>
        </v-flex>
        <v-flex class="border-left mx-1" xs4>
          <div class="body-2 text-xs-center">
            {{ listing.property.area }} Sq. Ft.
          </div>
          <div class="body-1 grey--text text-xs-center">
            ${{ setPricePerFoot(listing.listPrice, listing.property.area) }}/Sq.
            Ft.
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout row my-4>
      <v-flex class="grey--text text-xs-left">
        Status: <span class="text-dots">{{ listing.mls.statusText }}</span>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex class="grey--text text-xs-right">
        Days on the market:&nbsp;
        <span class="text-dots">{{ listing.mls.daysOnMarket }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'ListingHeader',
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setPricePerFoot(price, area) {
      if (!isFinite(price) || (!price && price !== 0)) return '';
      if (!isFinite(area) || (!area && area !== 0)) return '';

      return (Math.round(price) / area).toFixed(0);
    },
    setNumBaths(full, half) {
      return (full + half / 2).toString();
    },
  },
};
</script>

<style scoped>
.border-left {
  border-left: 1px solid #9e9e9e;
}

.text-dots {
  text-decoration: underline #9e9e9e dotted;
}
</style>
